export const CacheTime = {
  PRODUCTS: 60 * 3 * 1000,
  STORES: 60 * 10 * 1000,
  AVAILABILITY_PRODUCT: 60 * 10 * 1000,
};

export default CacheTime;
